import { useNavigate } from 'react-router-dom';

import STRAVA_LOGO from './strava white.svg';

function StravaButton ()
{
    const navigate = useNavigate ();

    return <button className="py-3 px-5 m-0 bg-black" onClick={ () => navigate ( '/participant/secure/strava' ) }>
                <img src={STRAVA_LOGO} className="h-4 inline mb-1" />
            </button>
}

export default StravaButton;